import { Helmet } from "react-helmet";
import Header from "../../../../Components/Header";
import EditForm from "./EditForm";

const EditItem = () => {
  return (
    <>
      <div className="d-flex flex-column" style={{ height: '100vh' }}>
      <Helmet>
				<title>Item - Edit</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column" style={{flexGrow:'1'}}>
        <EditForm />
      </div>
      </div>
    </>
  );
};

export default EditItem;
